module.exports = __webpack_public_path__ + "img/image17.50a85a87.jpeg";